import { InjectionToken } from '@angular/core';

export const EMPLOYEE_ID = new InjectionToken<number>('EMPLOYEE_ID');
export const NEW_MESSAGE = new InjectionToken<number>('NEW_MESSAGE');
export const TO_EMPLOYEE_ID = new InjectionToken<number>('TO_EMPLOYEE_ID');
export const WITH_EMPLOYEE_ID = new InjectionToken<number>('WITH_EMPLOYEE_ID');
export const PUNCH_WARNING_HASH = new InjectionToken<number>('PUNCH_WARNING_HASH');
export const CLOSE_METHOD = new InjectionToken<void>('CLOSE_METHOD');
